var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessenger(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3826 0.625H28.2552C12.8309 0.625 0.327148 13.1325 0.327148 28.5612V28.6888C0.327148 44.1175 12.8309 56.625 28.2552 56.625H28.3826C43.8068 56.625 56.3106 44.1175 56.3106 28.6888V28.5612C56.3106 13.1325 43.8068 0.625 28.3826 0.625Z",
    fill: "url(#paint0_linear_89_391)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9856 28.6241V28.7202C44.9405 36.7348 39.2094 43.4309 31.6287 44.9652C31.1148 45.0672 30.5951 45.1476 30.0655 45.2045C29.4928 45.2634 28.9083 45.2967 28.3199 45.2967C26.0054 45.2967 23.8008 44.8239 21.7963 43.9665L14.0626 44.7906C12.7426 44.9318 11.7678 43.584 12.315 42.3754L14.3941 37.7707C12.6622 35.1436 11.6521 31.9986 11.6521 28.6241C11.6521 19.4343 19.1308 11.9534 28.3199 11.9534C37.0087 11.9534 44.1658 18.6397 44.919 27.1389C44.9641 27.6254 44.9856 28.1257 44.9856 28.6241Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3322 23.7564C37.0795 23.1442 38.1053 24.0605 37.5796 24.8707L34.0806 30.27L32.229 33.1266C31.8348 33.7348 31.0071 33.88 30.4285 33.4425L27.3589 31.1137L25.4662 29.6795C25.3132 29.5637 25.0994 29.5677 24.9503 29.6893L20.3058 33.4798C19.5585 34.09 18.5347 33.1737 19.0604 32.3634L22.3378 27.3095L24.1893 24.4529C24.5836 23.8446 25.4113 23.6995 25.9899 24.137L28.9692 26.3952L30.86 27.8274C31.0149 27.9432 31.2287 27.9392 31.3778 27.8176L36.3322 23.7544V23.7564Z",
    fill: "url(#paint1_linear_89_391)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_89_391",
    x1: 8.50608,
    y1: 48.4437,
    x2: 48.1414,
    y2: 8.81999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0498FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5C5EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F44E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8679"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_89_391",
    x1: 21.3728,
    y1: 35.6262,
    x2: 35.3282,
    y2: 21.6749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0498FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#5C5EFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#F44E90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8679"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessenger);
export default __webpack_public_path__ + "static/media/messenger.8177ac7e9c25c3d4eeca9b45665a08bf.svg";
export { ForwardRef as ReactComponent };